import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { tap} from 'rxjs/operators';
import { ClubService } from '../../firebase/club.service';
import * as ClubActions from './club.actions';
import { ProfileService } from '../../firebase/profile.service';
import { NavController } from '@ionic/angular';

@Injectable()
export class ClubEffects {
    constructor(
        private clubService: ClubService,
        private profileService: ProfileService,
        private actions$: Actions,
        public navCtrl: NavController,
    ) {}

    clubEntered$ = createEffect(() => this.actions$.pipe(
        ofType(ClubActions.clubEnteredAction),
        tap((action) => {
            this.profileService.updateCurrentClubID(action.clubId);
        }),
    ), { dispatch: false });

    userExitedClub$ = createEffect(() => this.actions$.pipe(
        ofType(ClubActions.clubLeftAction),
        tap(() => {
            this.clubService.stopWatchingClub();
        }),
    ), { dispatch: false });
}
